import { lazy } from "react";

export const EnterpriseDashboard = lazy(
  () => import("./EnterpriseDashboard/EnterpriseDashboard"),
);

export const EnterpriseInvoice = lazy(
  () => import("./EnterpriseInvoice/EnterpriseInvoice"),
);

export const EnterpriseInvoiceDetails = lazy(
  () =>
    import("./EnterpriseInvoice/EnterpriseInvoiceDetails/EnterpriseInvoiceDetails"),
);

export const EnterpriseMakeOffer = lazy(
  () =>
    import("./EnterpriseInvoice/EnterpriseMakeOffer/EnterpriseMakeOffer"),
);

export const EnterpriseProduct = lazy(
  () => import("./EnterpriseProduct/EnterpriseProduct"),
);

export const EnterpriseProductSingle = lazy(
  () => import("./EnterpriseProductSingle/EnterpriseProductSingle"),
);

export const EnterpriseCart = lazy(
  () => import("./EnterpriseCart/EnterpriseCart"),
);

export const EnterpriseCheckout = lazy(
  () => import("./EnterpriseCheckout/EnterpriseCheckout"),
);

export const EnterpriseOrderCompleted = lazy(
  () => import("./EnterpriseOrderCompleted/EnterpriseOrderCompleted"),
);

export const EnterpriseWareHouseManagement = lazy(
  () =>
    import("./EnterpriseWareHouseManagement/EnterpriseWareHouseManagement"),
);

export const EnterpriseWareHouseShipToSite = lazy(
  () =>
    import("./EnterpriseWareHouseManagement/EnterpriseWareHouseShipToSite/EnterpriseWareHouseShipToSite"),
);

export const EnterpriseWareHouseShipToSiteCheckout = lazy(
  () =>
    import("./EnterpriseWareHouseManagement/EnterpriseWareHouseShipToSiteCheckout/EnterpriseWareHouseShipToSiteCheckout"),
);

export const EnterpriseWareHouseShipToSiteRequestSent = lazy(
  () =>
    import("./EnterpriseWareHouseManagement/EnterpriseWareHouseShipToSiteRequestSent/EnterpriseWareHouseShipToSiteRequestSent"),
);

export const EnterpriseWareHouseShipToSiteDetail = lazy(
  () =>
    import("./EnterpriseWareHouseManagement/EnterpriseWareHouseShipToSiteDetail/EnterpriseWareHouseShipToSiteDetail"),
);

export const EnterpriseOrderManagement = lazy(
  () =>
    import("./EnterpriseOrderManagement/EnterpriseOrderManagement"),
);

export const EnterpriseBulkOrderManagement = lazy(
  () =>
    import("./EnterpriseOrderManagement/EnterpriseBulkOrderManagement"),
);

export const EnterpriseOrderDetails = lazy(
  () =>
    import("./EnterpriseOrderManagement/EnterpriseOrderDetails/EnterpriseOrderDetails"),
);

export const EnterpriseBankingAndFinance = lazy(
  () =>
    import("./EnterpriseBankingAndFinance/EnterpriseBankingAndFinance"),
);

export const EnterpriseWalletHistory = lazy(
  () =>
    import("./EnterpriseBankingAndFinance/EnterpriseWalletHistory/EnterpriseWalletHistory"),
);

export const EnterpriseUserManagement = lazy(
  () => import("./EnterpriseUserManagement/EnterpriseUserManagement"),
);

export const EnterpriseAddNewUser = lazy(
  () =>
    import("./EnterpriseUserManagement/EnterpriseAddNewUser/EnterpriseAddNewUser"),
);

export const EnterpriseEditUser = lazy(
  () =>
    import("./EnterpriseUserManagement/EnterpriseEditUser/EnterpriseEditUser"),
);

export const EnterprisePLP = lazy(
  () => import("./EnterprisePLP/EnterprisePLP"),
);

export const EnterprisePLPMainPage = lazy(
  () =>
    import("./EnterprisePLP/EnterprisePLPMainPage/EnterprisePLPMainPage"),
);

export const EnterprisePLPApplicationForm = lazy(
  () =>
    import("./EnterprisePLP/EnterprisePLPApplicationForm/EnterprisePLPApplicationForm"),
);

export const EnterpriseSettings = lazy(
  () => import("./EnterpriseSettings/EnterpriseSettings"),
);

export const EnterpriseSettingsMain = lazy(
  () =>
    import("./EnterpriseSettings/EnterpriseSettingsMain/EnterpriseSettingsMain"),
);

export const EnterpriseSettingsProfile = lazy(
  () =>
    import("./EnterpriseSettings/EnterpriseSettingsProfile/EnterpriseSettingsProfile"),
);

export const EnterpriseSettingsSecurity = lazy(
  () =>
    import("./EnterpriseSettings/EnterpriseSettingsSecurity/EnterpriseSettingsSecurity"),
);

export const EnterpriseSettingsAddressBook = lazy(
  () =>
    import("./EnterpriseSettings/EnterpriseSettingsAddressBook/EnterpriseSettingsAddressBook"),
);

export const EnterpriseSettingsBankAndFinance = lazy(
  () =>
    import("./EnterpriseSettings/EnterpriseSettingsBankAndFinance/EnterpriseSettingsBankAndFinance"),
);

export const EnterpriseSettingsBusinessProfile = lazy(
  () =>
    import("./EnterpriseSettings/EnterpriseSettingsBusinessProfile/EnterpriseSettingsBusinessProfile"),
);

export const EnterpriseSettingsNotification = lazy(
  () =>
    import("./EnterpriseSettings/EnterpriseSettingsNotification/EnterpriseSettingsNotification"),
);

export const EnterpriseNotification = lazy(
  () => import("./EnterpriseNotification/EnterpriseNotification"),
);

export const EnterpriseContactUsPage = lazy(
  () => import("./EnterpriseContactUsPage/EnterpriseContactUsPage"),
);

export const EnterpriseSavedListPage = lazy(
  () => import("./EnterpriseSavedListPage/EnterpriseSavedListPage"),
);

export const EnterprisePaymentCompleted = lazy(
  () =>
    import("./EnterprisePaymentCompleted/EnterprisePaymentCompleted"),
);

export const EnterPriseMobileMenuTutorial = lazy(
  () =>
    import("./EnterPriseMobileMenuTutorial/EnterPriseMobileMenuTutorial"),
);

export const EnterpriseQuote = lazy(
  () => import("./EnterpriseQuote/EnterpriseQuote"),
);

export const EnterpriseReorder = lazy(
  () => import("./EnterpriseReorder/EnterpriseReorder"),
);

//
export const EnterpriseWarehouseDetails = lazy(
  () =>
    import("./EnterpriseWareHouseManagement/EnterpriseWarehouseDetails/EnterpriseWarehouseDetails"),
);

export const EnterpriseWareHouseOrder = lazy(
  () => import("./EnterpriseWareHouseOrder/EnterpriseWareHouseOrder"),
);

export const EnterpriseQuoteDetails = lazy(
  () => import("./EnterpriseQuoteDetails/EnterpriseQuoteDetails"),
);
export const EnterpriseActiveRequest = lazy(
  () =>
    import("./EnterpriseQuote/EnterpriseQuoteRequest/EnterpriseActiveRequest/EnterpriseActiveRequest"),
);
export const EnterprisePendingResponse = lazy(
  () =>
    import("./EnterpriseQuote/EnterpriseQuoteRequest/EnterprisePendingResponse/EnterprisePendingResponse"),
);
